var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 125,
    viewBox: "0 0 92 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8836_20434)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.144287,
    width: 91,
    height: 125,
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 33.5801,
    width: 27.1834,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 38.377,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 41.5752,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 47.9697,
    width: 27.1834,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 52.7666,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 55.9648,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 62.3613,
    width: 27.1834,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 67.1582,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 70.3564,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 76.7539,
    width: 27.1834,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 81.5508,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 84.749,
    width: 35.1785,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 95.9424,
    width: 27.1834,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 100.739,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 103.938,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 107.136,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 110.334,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73853,
    y: 113.531,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 14.3926,
    width: 33.5795,
    height: 6.39609,
    rx: 3.19804,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.73828,
    y: 22.3877,
    width: 19.1883,
    height: 1.59902,
    rx: 0.799511,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.917,
    y: 9.59473,
    width: 31.9804,
    height: 31.9804,
    rx: 15.9902,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1051,
    y: 30.3818,
    width: 17.5892,
    height: 17.5892,
    rx: 8.79462,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9121,
    y: 55.9658,
    width: 28.7824,
    height: 9.59413,
    rx: 3.19804,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9121,
    y: 68.7588,
    width: 28.7824,
    height: 9.59413,
    rx: 3.19804,
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9121,
    y: 81.5508,
    width: 28.7824,
    height: 9.59413,
    rx: 3.19804,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2106 24.9967C63.3567 24.2938 64.1213 23.0294 64.1213 21.5864C64.1213 19.3786 62.3315 17.5889 60.1237 17.5889C57.9159 17.5889 56.1261 19.3786 56.1261 21.5864C56.1261 23.0294 56.8907 24.2938 58.0368 24.9967C56.1941 25.7554 54.8261 27.4892 54.5234 29.5848C54.4431 30.141 54.7535 30.5986 55.3092 30.6826C56.0683 30.7972 57.4884 30.9141 60.1237 30.9141C62.759 30.9141 64.1791 30.7972 64.9382 30.6826C65.4939 30.5986 65.8043 30.141 65.724 29.5848C65.4213 27.4892 64.0533 25.7554 62.2106 24.9967Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8836_20434"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.144287,
    width: 91.1442,
    height: 124.724,
    rx: 4.79707,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.645800a50165cccf33b7494bc4dc9e8a.svg";
export { ForwardRef as ReactComponent };